import {
  getClaimMembers,
  getClaimSummaryForMember,
  getClaimDetailsForClaim,
  getPaymentDetailsForClaimAndInvoice,
  getPaymentDetailsForNotification,
  getClaimConditionForMember,
  getMemberDetailsService
} from "./../../services/ClaimsService";

import { getFastTrackAppointments } from "./../../services/FastTrackAppointmentsService";
import { Paths } from "../../constants/UrlConstants";
import { redirectToErrorPageMessage } from "../../logging/CommonLogMessages";
import { trackException } from "../../logging/AppInsightsLogger";

export const SET_CLAIM_MEMBERS = "SET_CLAIM_MEMBERS";
export const SET_PAYMENT_DETAILS_FOR_CLAIM_AND_INVOICE =
  "SET_PAYMENT_DETAILS_FOR_CLAIM_AND_INVOICE";
export const SET_PAYMENT_DETAILS_FOR_NOTIFICATION =
  "SET_PAYMENT_DETAILS_FOR_NOTIFICATION";
export const SET_CLAIM_DETAILS_FOR_CLAIM = "SET_CLAIM_DETAILS_FOR_CLAIM";
export const SET_CLAIMS_SUMMARY_FOR_SELECTED_MEMBER =
  "SET_CLAIMS_SUMMARY_FOR_SELECTED_MEMBER";
export const SET_CLAIMS_CONDITION = "SET_CLAIMS_CONDITION";

export const SET_FAST_TRACK_APPOINTMENTS = "SET_FAST_TRACK_APPOINTMENTS";
export const SET_MEMBER_DETAIL = "SET_MEMBER_DETAIL";

export function setClaimMembers(membershipNumber, history) {
  return async (dispatch, getState) => {
    let state = getState();
    let response = state.claimsReducer.selectedPolicy.claimMembers;
    if (response.length === 0) {
      response = await getClaimMembers(membershipNumber);
      dispatchActionForResponse(dispatch, response, SET_CLAIM_MEMBERS, history);
    }
  };
}

export function setClaimSummaryForMember(
  membershipNumber,
  securityId,
  history
) {
  return async (dispatch, getState) => {
    let selectedMember = getMemberFromStateBySecurityId(getState(), securityId);

    if (doesMemberHaveClaimSummary(selectedMember)) {
      dispatch({
        type: SET_CLAIMS_SUMMARY_FOR_SELECTED_MEMBER,
        payload: selectedMember
      });
    } else {
      let response = await getClaimSummaryForMember(
        membershipNumber,
        securityId
      );
      dispatchActionForResponse(
        dispatch,
        response,
        SET_CLAIMS_SUMMARY_FOR_SELECTED_MEMBER,
        history
      );
    }
  };
}

export function setClaimDetailsForClaim(claimReference, securityId, history) {
  return async (dispatch, getState) => {
    let redirectToClaimDetails = Paths.ClaimDetails;
    let selectedMember = getMemberFromStateBySecurityId(getState(), securityId);
    let payloadData = {
      selectedMember: selectedMember,
      selectedClaimNumber: claimReference
    };

    if (
      doesMemberHaveClaimSummary(selectedMember) &&
      doesMemberHaveDetailsForClaim(selectedMember, claimReference)
    ) {
      dispatch({
        type: SET_CLAIM_DETAILS_FOR_CLAIM,
        payload: payloadData
      });
      history.push(redirectToClaimDetails);
    } else {
      let response = await getClaimDetailsForClaim(claimReference);

      dispatchActionForResponse(
        dispatch,
        setResponseDataForMember(response, payloadData, claimReference),
        SET_CLAIM_DETAILS_FOR_CLAIM,
        history,
        redirectToClaimDetails
      );
    }
  };
}

export function setPaymentDetailsForClaimAndInvoice(
  claimReference,
  partialReference,
  history
) {
  return async (dispatch, getState) => {
    let redirectToPaymentDetails = Paths.PaymentDetails;
    let membershipNumber = getState().policyReducer.selectedPolicy
      .MembershipNumber;
    let securityId = getState().claimsReducer.selectedPolicy.selectedClaimMember
      .SecurityId;
    let selectedClaim = getState().claimsReducer.selectedPolicy.selectedClaim;
    let selectedInvoice = selectedClaim.ClaimDetails.Invoices.find(
      (i) => i.PartialInvoiceReference === partialReference
    );
    if (selectedInvoice.PaymentDetails) {
      dispatch({
        type: SET_PAYMENT_DETAILS_FOR_CLAIM_AND_INVOICE,
        payload: selectedInvoice.PaymentDetails
      });
      history.push(redirectToPaymentDetails);
    } else {
      let response = await getPaymentDetailsForClaimAndInvoice(
        claimReference,
        partialReference,
        membershipNumber,
        securityId
      );
      dispatchActionForResponse(
        dispatch,
        response,
        SET_PAYMENT_DETAILS_FOR_CLAIM_AND_INVOICE,
        history,
        redirectToPaymentDetails
      );
    }
  };
}

export function setPaymentDetailsForNotification(
  invoiceReference,
  history,
  notificationSecurityId
) {
  return async (dispatch, getState) => {
    var membershipNumber = getState().policyReducer.selectedPolicy
      .MembershipNumber;
    var response = await getPaymentDetailsForNotification(
      invoiceReference,
      membershipNumber,
      notificationSecurityId
    );

    if (response && response.status === 200 && response.data) {
      var paymentDetails = response.data;
      var isPaymentNeededByMember =
        paymentDetails.TotalMemberLiabilityAmount > 0;
      dispatch({
        type: SET_PAYMENT_DETAILS_FOR_NOTIFICATION,
        payload: {
          isPaymentNeededByMember,
          paymentDetails
        }
      });
      history.push(Paths.PaymentDetails);
    } else {
      trackException(
        redirectToErrorPageMessage,
        `Something went wrong while set payment details for notification. ResponseStatus: ${JSON.stringify(
          response && response.status
        )} Membershipnumber:${membershipNumber}`
      );
      history.push(Paths.Error);
    }
  };
}

export function setFastTrackAppointments(membershipNumber) {
  return async (dispatch, getState) => {
    let state = getState();
    let appointments =
      state &&
      state.claimsReducer &&
      state.claimsReducer.selectedPolicy.appointments;
    if (appointments && appointments.length > 0) {
      return appointments;
    } else {
      let response = await getFastTrackAppointments(membershipNumber);
      dispatch({ type: SET_FAST_TRACK_APPOINTMENTS, payload: response });
      return response.appointments;
    }
  };
}

function getMemberFromStateBySecurityId(state, securityId) {
  return state.claimsReducer.selectedPolicy.claimMembers.find(
    (m) => m.SecurityId === securityId
  );
}

function doesMemberHaveClaimSummary(member) {
  return member && Array.isArray(member.Conditions);
}

function doesMemberHaveDetailsForClaim(member, claimReference) {
  let claimDetails;
  if (member.Conditions.length > 0) {
    claimDetails = member.Conditions.find(
      (c) => c.ClaimDetails && c.ClaimDetails.ClaimReference === claimReference
    );
  }
  return claimDetails;
}

function dispatchActionForResponse(
  dispatch,
  response,
  action,
  history,
  pathTo
) {
  if (response && response.status === 200 && response.data) {
    dispatch({
      type: action,
      payload: response.data
    });
    if (pathTo) {
      history.push(pathTo);
    }
  } else {
    history.replace(Paths.Error);
  }
}

function setResponseDataForMember(response, payloadData, claimReference) {
  if (response.status === 200) {
    let selectedConditionIndex = payloadData.selectedMember.Conditions.findIndex(
      (m) => m.ClaimNumber === claimReference
    );
    payloadData.selectedMember.Conditions[selectedConditionIndex].ClaimDetails =
      response.data;
    response.data = payloadData;
  }
  return response;
}

export function getMemberDetails(policyNumber,history){
return async (dispatch) => {
  let ssoId="";
    let response = await getMemberDetailsService(policyNumber,ssoId);
     if (response && response.status === 200 && response.data) {
          try{
           dispatch({
              type: SET_MEMBER_DETAIL,
              payload: response.data
            });
        }
        catch(e){
          dispatch({
            type: SET_MEMBER_DETAIL,
            payload: null
          });
        }}
        else{
          history.replace(Paths.Error);
        }
        }; 
}
export function setClaimCondition(policyNumber,memberplanId,history)
{
  return async (dispatch) => {
    let ssoId="";
    let response = await getClaimConditionForMember(ssoId,policyNumber,memberplanId);
    if (response && response.status === 200 && response.data) {
          try{
           dispatch({
              type: SET_CLAIMS_CONDITION,
              payload: response.data
            });
        }
        catch(e){
          dispatch({
            type: SET_CLAIMS_CONDITION,
            payload: null
          });
        }
      }
      else{
        history.replace(Paths.Error);
      }
        }; 
}
